/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateAccountEntitlementsResult} from '../models/UpdateAccountEntitlementsResult';
import type {UpdateEntitiesEntitlementsRelation} from '../models/UpdateEntitiesEntitlementsRelation';

export interface BulkAssignAccountsEntitlements$Request {
    updateEntitiesEntitlementsRelation: UpdateEntitiesEntitlementsRelation;
    reason?: string;
}

export interface BulkAssignAccountsEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignAccountsEntitlementsRequest = createAction<PayloadData<void, BulkAssignAccountsEntitlements$Request>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__REQUEST');
export const bulkAssignAccountsEntitlementsSuccess = createAction<PayloadData<string, BulkAssignAccountsEntitlements$Request>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__SUCCESS');
export const bulkAssignAccountsEntitlementsFailure = createAction<PayloadData<Error, BulkAssignAccountsEntitlements$Request, true>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__FAILURE');

export const bulkAssignAccountsEntitlementsActions = [
    bulkAssignAccountsEntitlementsRequest,
    bulkAssignAccountsEntitlementsSuccess,
    bulkAssignAccountsEntitlementsFailure
] as const;

/**
 * @param {UpdateEntitiesEntitlementsRelation} meta.updateEntitiesEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignAccountsEntitlements = (meta: BulkAssignAccountsEntitlements$Request, config?: BulkAssignAccountsEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkAssignAccountsEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/accounts/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateEntitiesEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignAccountsEntitlementsProgress$Request {
    id: string;
}

export interface GetAssignAccountsEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignAccountsEntitlementsProgressRequest = createAction<PayloadData<void, GetAssignAccountsEntitlementsProgress$Request>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__GET_ASSIGN_ACCOUNTS_ENTITLEMENTS_PROGRESS__REQUEST');
export const getAssignAccountsEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetAssignAccountsEntitlementsProgress$Request>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__GET_ASSIGN_ACCOUNTS_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getAssignAccountsEntitlementsProgressFailure = createAction<PayloadData<Error, GetAssignAccountsEntitlementsProgress$Request, true>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__GET_ASSIGN_ACCOUNTS_ENTITLEMENTS_PROGRESS__FAILURE');

export const getAssignAccountsEntitlementsProgressActions = [
    getAssignAccountsEntitlementsProgressRequest,
    getAssignAccountsEntitlementsProgressSuccess,
    getAssignAccountsEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignAccountsEntitlementsProgress = (meta: GetAssignAccountsEntitlementsProgress$Request, config?: GetAssignAccountsEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignAccountsEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/entitlements/assign/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignAccountsEntitlementsResult$Request {
    id: string;
}

export interface GetAssignAccountsEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignAccountsEntitlementsResultRequest = createAction<PayloadData<void, GetAssignAccountsEntitlementsResult$Request>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__GET_ASSIGN_ACCOUNTS_ENTITLEMENTS_RESULT__REQUEST');
export const getAssignAccountsEntitlementsResultSuccess = createAction<PayloadData<UpdateAccountEntitlementsResult, GetAssignAccountsEntitlementsResult$Request>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__GET_ASSIGN_ACCOUNTS_ENTITLEMENTS_RESULT__SUCCESS');
export const getAssignAccountsEntitlementsResultFailure = createAction<PayloadData<Error, GetAssignAccountsEntitlementsResult$Request, true>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__GET_ASSIGN_ACCOUNTS_ENTITLEMENTS_RESULT__FAILURE');

export const getAssignAccountsEntitlementsResultActions = [
    getAssignAccountsEntitlementsResultRequest,
    getAssignAccountsEntitlementsResultSuccess,
    getAssignAccountsEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignAccountsEntitlementsResult = (meta: GetAssignAccountsEntitlementsResult$Request, config?: GetAssignAccountsEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignAccountsEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopBulkActions$Request {
    id: string;
}

export interface StopBulkActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopBulkActionsRequest = createAction<PayloadData<void, StopBulkActions$Request>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__STOP_BULK_ACTIONS__REQUEST');
export const stopBulkActionsSuccess = createAction<PayloadData<void, StopBulkActions$Request>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__STOP_BULK_ACTIONS__SUCCESS');
export const stopBulkActionsFailure = createAction<PayloadData<Error, StopBulkActions$Request, true>>('BULK_ASSIGN_ACCOUNTS_ENTITLEMENTS__STOP_BULK_ACTIONS__FAILURE');

export const stopBulkActionsActions = [
    stopBulkActionsRequest,
    stopBulkActionsSuccess,
    stopBulkActionsFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopBulkActions = (meta: StopBulkActions$Request, config?: StopBulkActions$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopBulkActionsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/accounts/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

